import { render, staticRenderFns } from "./electricFireMg.vue?vue&type=template&id=5a4bf8db&scoped=true&"
import script from "./electricFireMg.vue?vue&type=script&lang=js&"
export * from "./electricFireMg.vue?vue&type=script&lang=js&"
import style0 from "./electricFireMg.vue?vue&type=style&index=0&id=5a4bf8db&prod&lang=scss&scoped=true&"
import style1 from "./electricFireMg.vue?vue&type=style&index=1&id=5a4bf8db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4bf8db",
  null
  
)

export default component.exports